/* Modelos de contrato, dados da contratada e minutas dos leads
   (backend /lead-contratos). */
import { apiFetch, API_URL, obterToken } from './apiClient';

const B = '/lead-contratos';

export const buscarContratada = () => apiFetch(`${B}/contratada`);
export const salvarContratada = (d) => apiFetch(`${B}/contratada`, { method: 'PUT', body: JSON.stringify(d) });

export const listarMarcadores = () => apiFetch(`${B}/marcadores`);
export const listarModelosContrato = () => apiFetch(`${B}/modelos`);
export const criarModeloContrato = (d) => apiFetch(`${B}/modelos`, { method: 'POST', body: JSON.stringify(d) });
export const atualizarModeloContrato = (id, d) => apiFetch(`${B}/modelos/${id}`, { method: 'PUT', body: JSON.stringify(d) });
export const excluirModeloContrato = (id) => apiFetch(`${B}/modelos/${id}`, { method: 'DELETE' });

export const listarMinutasLead = (leadId) => apiFetch(`${B}/lead/${leadId}/minutas`);
export const gerarMinutaLead = (leadId, modeloId) => apiFetch(`${B}/lead/${leadId}/minutas`, { method: 'POST', body: JSON.stringify({ modelo_id: modeloId }) });
export const buscarMinuta = (id) => apiFetch(`${B}/minutas/${id}`);
export const salvarMinuta = (id, d) => apiFetch(`${B}/minutas/${id}`, { method: 'PUT', body: JSON.stringify(d) });
export const excluirMinuta = (id) => apiFetch(`${B}/minutas/${id}`, { method: 'DELETE' });

/* baixa o PDF/DOCX da minuta (versão atual ou ?versao=N) */
export async function baixarMinuta(id, formato, nomeBase, versao) {
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}/minutas/${id}/${formato}${versao ? `?versao=${versao}` : ''}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!r.ok) {
    let msg = 'Erro ao gerar o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem corpo JSON */ }
    throw new Error(msg);
  }
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = `${nomeBase}.${formato}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export const TIPOS_MODELO = [
  { id: 'mensal', label: 'Prestação de serviços mensais' }, { id: 'abertura', label: 'Abertura' },
  { id: 'alteracao', label: 'Alteração' }, { id: 'transferencia', label: 'Transferência' },
  { id: 'baixa', label: 'Baixa' }, { id: 'outro', label: 'Outro' },
];
export const STATUS_MINUTA = [
  { id: 'rascunho', label: 'Rascunho' }, { id: 'em_revisao', label: 'Em revisão' },
  { id: 'aprovada', label: 'Aprovada' }, { id: 'enviada', label: 'Enviada para assinatura' },
];
